import { Check } from "lucide-react";

type Props = {
  checked: boolean;
  onChange: (checked: boolean) => void;
  label: string;
};

export function CheckboxToggle({ checked, onChange, label }: Props) {
  return (
    <label className="flex cursor-pointer items-center gap-1.5 font-mono text-xs font-medium uppercase tracking-widest text-text-secondary">
      <span
        className={`flex h-4 w-4 items-center justify-center rounded border transition-colors ${
          checked
            ? "border-text-secondary bg-bg-tertiary"
            : "border-border-accent bg-bg-secondary"
        }`}
      >
        {checked && <Check className="h-3 w-3 text-text-secondary" />}
      </span>
      <input
        type="checkbox"
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        className="sr-only"
      />
      {label}
    </label>
  );
}
